var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1117_162",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.890381,
    width: 24,
    height: 27.1233,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1117_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.01384 18.6553L3.04051 15.4699L1 12.2579L1.02899 12.182H4.41523C4.41523 11.8763 4.42413 11.5994 4.41227 11.3246C4.40304 11.1068 4.45937 11.0524 4.58291 11.0629C4.71962 11.0754 4.85733 11.066 4.9947 11.066H20.5769V12.1731H23.9881L21.9358 15.4061L24 18.6589H19.5395V17.0325C19.4644 17.0257 19.4061 17.0163 19.3481 17.0163C14.7799 17.0163 10.2125 17.0145 5.64566 17.011C5.49214 17.011 5.43417 17.066 5.44207 17.3251C5.45525 17.7591 5.4457 18.1951 5.4457 18.6553H1.01384ZM4.76476 16.4567H20.2356V11.6334H4.76476V16.4567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23145 16.5317V11.3656H20.3885V16.5317H4.23145Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhBanner);
export default __webpack_public_path__ + "static/media/wh_banner.1d887adce5baae52fe39bc8bcab22ba3.svg";
export { ForwardRef as ReactComponent };